import { Component, OnInit } from '@angular/core';
import { PlanFeature } from '../../models/plan-feature.model';
import { Plan } from '../../models/plan.model';
import { PlanVM, FeatureItemVM } from './home-section-plans.models';
import {
  FEATURE_PLAN_BASIC,
  FEATURE_PLAN_INTEGRATED,
  FEATURE_PLAN_PREMIUM,
} from './home-section-plans.constants';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-home-section-plans',
  standalone: true,
  imports: [FontAwesomeModule, TranslateModule],
  templateUrl: './home-section-plans.component.html',
  styleUrls: ['./home-section-plans.component.scss'],
})
export class HomeSectionPlansComponent implements OnInit {
  public titleKey = 'plans.title';
  public plans: Plan[] = [];

  ngOnInit(): void {
    this.plans = this.fetchPlans();
  }

  fetchPlans(): Plan[] {
    const allFeatures = Object.values(PlanFeature);
    return [
      new PlanVM(
        'basic',
        'plans.items.basic.title',
        '',
        allFeatures.map(
          (feature) => new FeatureItemVM(feature, FEATURE_PLAN_BASIC.includes(feature))
        )
      ),
      new PlanVM(
        'integrated',
        'plans.items.integrated.title',
        '',
        allFeatures.map(
          (feature) => new FeatureItemVM(feature, FEATURE_PLAN_INTEGRATED.includes(feature))
        )
      ),
      new PlanVM(
        'premium',
        'plans.items.premium.title',
        '',
        allFeatures.map(
          (feature) => new FeatureItemVM(feature, FEATURE_PLAN_PREMIUM.includes(feature))
        )
      ),
    ];
  }
}
